var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDisplayed)?_c('div',{staticClass:"modal",attrs:{"data-test-modal":""}},[_c('div',{staticClass:"modal__body"},[_c('CloseButton',{staticClass:"modal__close-btn",attrs:{"onClick":_vm.handleModalClose,"data-test-close-btn":""}}),_vm._t("default")],2)]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fa7aa00","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/Modal/Modal.vue
// module id = null
// module chunks = 